import React from 'react';
import { FadeIn } from './FadeIn';
export function ForYou() {
  return <section className="py-20 px-6 max-w-5xl mx-auto" data-id="element-115">
      <div className="grid md:grid-cols-2 gap-12" data-id="element-116">
        <FadeIn data-id="element-117">
          <div className="bg-sage/10 p-8 md:p-10 rounded-3xl border border-sage/20 h-full" data-id="element-118">
            <h3 className="text-2xl md:text-3xl font-bold text-sage-dark mb-8 font-serif" data-id="element-119">
              Este Libro Es Para Usted Si...
            </h3>
            <ul className="space-y-6" data-id="element-120">
              {['Tiene 60 años o más y prefiere lo natural sobre los químicos.', 'Vive en USA y quiere remedios con ingredientes locales.', 'Quiere tener energía para disfrutar a sus nietos sin quejarse de dolor.', 'Busca una solución económica, simple y en su idioma.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-121">
                  <span className="text-2xl mr-4 shrink-0" data-id="element-122">✅</span>
                  <span className="text-lg text-brown font-medium" data-id="element-123">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-124">
          <div className="bg-terracotta/5 p-8 md:p-10 rounded-3xl border border-terracotta/20 h-full" data-id="element-125">
            <h3 className="text-2xl md:text-3xl font-bold text-terracotta-dark mb-8 font-serif" data-id="element-126">
              Este Libro NO Es Para Usted Si...
            </h3>
            <ul className="space-y-6" data-id="element-127">
              {['Busca reemplazar una cirugía urgente con remedios caseros.', 'No está dispuesta a cambiar aunque sea un pequeño hábito diario.', 'Espera resultados sin hacer absolutamente nada.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-128">
                  <span className="text-2xl mr-4 shrink-0" data-id="element-129">❌</span>
                  <span className="text-lg text-brown font-medium" data-id="element-130">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}